module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-6.d62c6f1e.jpg";